import { createFileRoute, redirect } from '@tanstack/react-router'
import { HTTPError } from 'ky'
import { bootstrapQueryOptions } from '@/features/bootstrap/api/bootstrap/queries/bootstrap-query'
import { canManageOrganizationAsOwner } from '@/features/organizations/domain/organization-role'
import { requireAuthenticated } from '@/shared/lib/route-guards'
import { GTM_PRODUCT_SCOPE } from '@/shared/lib/gtm-product-scope'
import { redirectToGtmEntry } from '@/shared/lib/gtm-route-guard'

export const Route = createFileRoute('/$lang/organization/')({
  beforeLoad: async ({ context, params }) => {
    if (!GTM_PRODUCT_SCOPE.legacyWorkspaceUi) {
      redirectToGtmEntry(context, params)
    }
    requireAuthenticated(context, params)

    let bootstrap
    try {
      bootstrap = await context.queryClient.ensureQueryData(
        bootstrapQueryOptions(),
      )
    } catch (error) {
      if (error instanceof HTTPError && error.response.status === 403) {
        throw redirect({
          to: '/$lang/pending-approval',
          params: { lang: params.lang },
          replace: true,
        })
      }
      throw error
    }

    if (bootstrap.organization?.isVisible !== true) {
      throw redirect({
        to: '/$lang/settings/billing',
        params: { lang: params.lang },
      })
    }

    throw redirect({
      to: canManageOrganizationAsOwner(bootstrap.organization.role)
        ? '/$lang/settings/billing'
        : '/$lang/settings/organization',
      params: { lang: params.lang },
    })
  },
  staticData: { layout: 'full' },
})
